import { render, staticRenderFns } from "./productcenterzyjy.vue?vue&type=template&id=65d5388c&scoped=true&"
import script from "./productcenterzyjy.vue?vue&type=script&lang=js&"
export * from "./productcenterzyjy.vue?vue&type=script&lang=js&"
import style0 from "./productcenterzyjy.vue?vue&type=style&index=0&id=65d5388c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5388c",
  null
  
)

export default component.exports